import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { NumberToWords } from './NumberToWords'

const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
]

// Crear un nuevo documento PDF
export const createPdf = (
  fileName: string,
  serial: string,
  name: string,
  document: string,
  amount: number,
  amountFormat: string,
  rows: string[][],
  bankName?: string,
  accountType?: string,
  accountNumber?: number | string,
  accountDocument?: string,
  physicalAddress?: string,
  phone?: string
) => {
  const doc = new jsPDF()
  rows.push(['Total a pagar', '', '', '', '', '', '', `$${amountFormat}`])
  const date = new Date()
  const month = months[date.getMonth()]

  // Agregar el texto al documento
  doc.setFontSize(12)
  doc.text(`Ibagué, ${month} ${date.getDate()} del ${date.getFullYear()}`, 100, 10, { align: 'center' })
  doc.text('CO CAPITALIZACIONES SAS', 100, 20, { align: 'center' })
  doc.text('Nit. 901322825-1', 100, 25, { align: 'center' })
  doc.text(`Consecutivo: ${serial}`, 100, 30, { align: 'center' })
  doc.text('DEBE A:', 100, 40, { align: 'center' })
  doc.text(name.toUpperCase(), 100, 45, { align: 'center' })
  doc.text(`C.C. ${document}`, 100, 50, { align: 'center' })
  doc.text('la suma de:', 100, 55, { align: 'center' })
  doc.text(`${NumberToWords(amount)}PESOS`, 100, 60, { align: 'center' })
  doc.text(`($${amountFormat})`, 100, 65, { align: 'center' })

  doc.text('A continuación, se presenta la relación de comisiones y deducciones aplicadas:', 15, 85)
  autoTable(doc, {
    head: [
      [
        'REFERIDO',
        'HONORARIOS SIN IVA',
        'PORCENTAJE COMISIÓN',
        'PORCENTAJE POR PATROCINIO',
        'ANTICIPO',
        'COMISIÓN',
        'COMISIÓN POR PATROCINIO',
        'TOTAL COMISIÓN'
      ]
    ],
    body: rows,
    theme: 'grid',
    startY: 90,
    headStyles: {
      fillColor: [252, 100, 4],
      fontSize: 8
    }
  })
  let lastY = (doc as any).lastAutoTable.finalY
  doc.text('Cordialmente,', 15, (lastY += 20))
  doc.text('___________________________', 15, (lastY += 10))
  doc.text(name.toUpperCase(), 15, (lastY += 5))
  doc.text(`C.C. ${document}`, 15, (lastY += 5))
  lastY += 20
  if (lastY >= 280) {
    doc.addPage()
    lastY = 10
  }
  doc.text('Datos para pago:', 15, (lastY += 5))
  doc.text(`Banco: ${bankName}`, 15, (lastY += 5))
  doc.text(`Tipo de cuenta: ${accountType}`, 15, (lastY += 5))
  doc.text(`Numero de cuenta: ${accountNumber}`, 15, (lastY += 5))
  doc.text(`Cédula de la cuenta: ${accountDocument}`, 15, (lastY += 5))
  doc.text(`Telefono: ${phone}`, 15, (lastY += 5))
  doc.text(`Direccion: ${physicalAddress}`, 15, (lastY += 5))

  if (lastY >= 260) {
    doc.addPage()
    lastY = 15
  }

  doc.setFontSize(9)
  doc.text(
    'Declaro bajo gravedad de juramento que con el fin de acogerme a la tabla del artículo 383 del estatuto tributario respecto a la retención en la fuente, que en mi declaración de renta no voy a tomarme costos ni deducciones.',
    15,
    lastY + 12,
    { maxWidth: 180 }
  )
  doc.save(`${fileName}.pdf`)
}

export const createPrepaymentPdf = (
  fileName: string,
  serial: string,
  name: string,
  document: string,
  amount: number,
  amountFormat: string,
  rows: string[][],
  bankName?: string,
  accountType?: string,
  accountNumber?: number | string,
  physicalAddress?: string,
  phone?: string
) => {
  const doc = new jsPDF()
  rows.push(['Total a pagar', '', `${amountFormat}`])
  const date = new Date()
  const month = months[date.getMonth()]

  // Agregar el texto al documento
  doc.setFontSize(12)
  doc.text(`Ibagué, ${month} ${date.getDate()} del ${date.getFullYear()}`, 100, 10, { align: 'center' })
  doc.text('CO CAPITALIZACIONES SAS', 100, 20, { align: 'center' })
  doc.text('Nit. 901322825-1', 100, 25, { align: 'center' })
  doc.text(`Consecutivo: ${serial}`, 100, 30, { align: 'center' })
  doc.text('DEBE A:', 100, 40, { align: 'center' })
  doc.text(name.toUpperCase(), 100, 45, { align: 'center' })
  doc.text(`C.C. ${document}`, 100, 50, { align: 'center' })
  doc.text('la suma de:', 100, 55, { align: 'center' })
  doc.text(`${NumberToWords(amount)}PESOS`, 100, 60, { align: 'center' })
  doc.text(`(${amountFormat})`, 100, 65, { align: 'center' })

  doc.text('A continuación, se presenta la relación de anticipos por referidos:', 15, 85)
  autoTable(doc, {
    head: [['REFERIDO', 'HONORARIOS SIN IVA', 'VALOR ANTICIPO']],
    body: rows,
    theme: 'grid',
    startY: 90,
    headStyles: {
      fillColor: [252, 100, 4]
    }
  })
  let lastY = (doc as any).lastAutoTable.finalY
  doc.text('Cordialmente,', 15, (lastY += 20))
  doc.text('___________________________', 15, (lastY += 10))
  doc.text(name.toUpperCase(), 15, (lastY += 5))
  doc.text(`C.C. ${document}`, 15, (lastY += 5))
  lastY += 20
  if (lastY >= 280) {
    doc.addPage()
    lastY = 10
  }
  doc.text('Datos para pago:', 15, (lastY += 5))
  doc.text(`Banco: ${bankName}`, 15, (lastY += 5))
  doc.text(`Tipo de cuenta: ${accountType}`, 15, (lastY += 5))
  doc.text(`Numero de cuenta: ${accountNumber}`, 15, (lastY += 5))
  doc.text(`Telefono: ${phone}`, 15, (lastY += 5))
  doc.text(`Direccion: ${physicalAddress}`, 15, (lastY += 5))

  if (lastY >= 260) {
    doc.addPage()
    lastY = 15
  }

  doc.setFontSize(9)
  doc.text(
    'Declaro bajo gravedad de juramento que con el fin de acogerme a la tabla del artículo 383 del estatuto tributario respecto a la retención en la fuente, que en mi declaración de renta no voy a tomarme costos ni deducciones.',
    15,
    lastY + 12,
    { maxWidth: 180 }
  )
  doc.save(`${fileName}.pdf`)
}
